import { Card, CardContent, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";

const CustomCardComponent = ({ item, ...props }) => {

    const { content } = item;
    const { reducer } = useSelector((state) => state);
    const { isSiteBuilder, pageJson } = reducer;
    const { title } = content || {};
    const fontFamily = pageJson?.pageStyle?.fontFamily || 'Roboto';

    return (
        <Card
            {...props}
            sx={{
                ...props.sx,
                width: "100%",
                borderRadius: "24px",
                textAlign: "center",
                height: '100%',
                ...item?.props?.style, // Apply styles from editor
                ...props.style
            }}
            onClick={() => {
                if (item?.url) {
                    if (typeof item?.url === "object") {
                        if (item?.url?.target) {
                            window.open(item?.url?.path, "_blank", "noopener,noreferrer");
                        } else {
                            // Handle internal navigation if needed, or rely on parentLink
                            window.location.href = item?.url?.path;
                        }
                    } else {
                        window.location.href = item?.url;
                    }
                }
            }}
        >
            <CardContent>
                <Stack spacing={1} alignItems={item?.props?.alignItems || 'center'} >

                    {title && (() => {
                        const { backgroundColor, borderColor, borderWidth, borderStyle, ...titleStyle } = item?.props?.style || {};
                        return <Typography  sx={{ ...titleStyle , fontFamily: `${fontFamily}!important`,}} >{title}</Typography>
                    })()}
                    {content?.content && <Typography variant="body2" sx={{ ...item?.props?.style2 ,fontFamily: `${fontFamily}!important`,}} >{content?.content}</Typography>}

                </Stack>
            </CardContent>
        </Card>
    );
};

export default CustomCardComponent;
